import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {useFileViewerStore} from '../file-viewer-store'
import IconLeft from '../icons/icon-left.svg'
import IconRight from '../icons/icon-right.svg'

const TwIconWrapper = tw.div`
  w-24
  h-24
  cursor-pointer
  rounded-4
  hover:bg-project-hover-old-dark
  active:bg-main-old-dark
  select-none
`

const TwIcon = tw.div`
  flex
  items-center
  justify-center
  h-full
`

const TwIconIndent = tw.div`
  mb-8
`

export const Prev = observer(() => {
  const [state, store] = useFileViewerStore()
  const onPrevious = () => {
    store.setCurrentFileIndex(state.currentFileIndex - 1)
  }
  return state.currentFileIndex > 0 ? (
    <TwIconIndent>
      <TwIconWrapper onClick={onPrevious}>
        <TwIcon>
          <IconLeft className="text-third-old-dark" />
        </TwIcon>
      </TwIconWrapper>
    </TwIconIndent>
  ) : (
    <div className="w-18"></div>
  )
})

export const Next = observer(({lastPage}: {lastPage: number | string}) => {
  const [state, store] = useFileViewerStore()
  const onNext = () => {
    store.setCurrentFileIndex(state.currentFileIndex + 1)
  }
  return state.currentFileIndex !== lastPage ? (
    <TwIconIndent>
      <TwIconWrapper onClick={onNext}>
        <TwIcon>
          <IconRight className="text-third-old-dark" />
        </TwIcon>
      </TwIconWrapper>
    </TwIconIndent>
  ) : (
    <div className="w-18"></div>
  )
})
